import React from 'react';
import {
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Table,
  LinearProgress,
  Tooltip
} from '@material-ui/core'

import { WaitingPassengerOptions } from 'components'

const COLUMNS = [
  "#",
  "Прізвище",
  "Імя",
  "Телефон",
  "Звідки",
  "Куди",
]

const renderTableHeadCell = label => (
  <TableCell padding='dense' key={label}>
    {label}
  </TableCell>
)

export const WaitingListTable = props => {
  const renderPassenger = ({
    id, surname, name, phone, from, to, createdDate, userName
  }, index) => (
    <TableRow key={id}>
      <TableCell padding='none'>
        <WaitingPassengerOptions passengerId={id} />
      </TableCell>

      <TableCell padding='dense'>
        {props.isPartner || props.isLimitedDispatcher
          ? index + 1
          : (
            <Tooltip title={`${createdDate} | ${userName}`}>
              <div>
                {index + 1}
              </div>
            </Tooltip>
          )}
      </TableCell>

      <TableCell padding='dense'>
        {surname}
      </TableCell>

      <TableCell padding='dense'>
        {name}
      </TableCell>

      <TableCell padding='dense'>
        {phone}
      </TableCell>

      <TableCell padding='dense'>
        {from}
      </TableCell>

      <TableCell padding='dense'>
        {to}
      </TableCell>
    </TableRow>
  )


  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell padding='none' />
          {COLUMNS.map(renderTableHeadCell)}
        </TableRow>
      </TableHead>
      <TableBody>
        {props.isLoading && (
          <TableRow>
            <TableCell colSpan='7'>
              <LinearProgress />
            </TableCell>
          </TableRow>
        )}
        {props.waitingPassengersIsEmpty && (
          <TableRow>
            <TableCell colSpan='7' className={props.classes.emptyCell}>
              Пасажири відсутні
            </TableCell>
          </TableRow>
        )}
        {props.waitingPassengers.map(renderPassenger)}
      </TableBody>
    </Table>
  )
}



// WEBPACK FOOTER //
// ./src/components/WaitingListTable/WaitingListTable.js